// import { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
// import api from "../api/axiosInstance";

// const ResetPassword = () => {
//   const location = useLocation();
//   const email = location.state?.email || "";
//   const [otp, setOtp] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [step, setStep] = useState(1); // 1: Enter OTP, 2: Enter new password
//   const navigate = useNavigate();

//   const verifyOtp = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     try {
//       const response = await api.post("/password/verify-reset-otp", {
//         email,
//         otp,
//       });

//       if (response.data.success) {
//         toast.success("OTP verified!");
//         setStep(2);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Invalid OTP");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleResetPassword = async (e) => {
//     e.preventDefault();

//     if (password !== confirmPassword) {
//       toast.error("Passwords don't match");
//       return;
//     }

//     if (password.length < 8) {
//       toast.error("Password must be at least 8 characters");
//       return;
//     }

//     setIsLoading(true);

//     try {
//       const response = await api.post("/password/reset", {
//         email,
//         otp,
//         newPassword: password,
//         confirmPassword,
//       });

//       if (response.data.success) {
//         toast.success("Password reset successfully!");
//         navigate("/login");
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Password reset failed");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const resendOtp = async () => {
//     try {
//       await api.post("/password/forgot-password", null, { params: { email } });
//       toast.success("OTP resent to your email!");
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Error resending OTP");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#fffdf7] flex items-center justify-center p-4">
//       <div className="max-w-md w-full bg-[#fcfaec] rounded-xl p-8 md:p-10 shadow-lg">
//         <h1 className="text-3xl font-bold text-black mb-6 text-center">
//           Reset Password
//         </h1>

//         {step === 1 ? (
//           <form onSubmit={verifyOtp} className="space-y-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Enter OTP
//               </label>
//               <input
//                 type="text"
//                 value={otp}
//                 onChange={(e) =>
//                   setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
//                 }
//                 className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-lime-400 text-center text-2xl font-mono"
//                 placeholder="000000"
//                 required
//                 maxLength={6}
//               />
//               <p className="text-sm text-gray-500 mt-2">
//                 Enter the 6-digit OTP sent to {email}
//               </p>
//             </div>

//             <button
//               type="submit"
//               disabled={isLoading || otp.length !== 6}
//               className={`w-full py-3 px-4 rounded-full font-bold text-white ${
//                 isLoading || otp.length !== 6
//                   ? "bg-gray-400"
//                   : "bg-lime-500 hover:bg-lime-600"
//               } transition duration-200`}
//             >
//               {isLoading ? "Verifying..." : "Verify OTP"}
//             </button>

//             <div className="text-center">
//               <button
//                 type="button"
//                 onClick={resendOtp}
//                 className="text-lime-600 hover:text-lime-800 font-medium"
//               >
//                 Resend OTP
//               </button>
//             </div>
//           </form>
//         ) : (
//           <form onSubmit={handleResetPassword} className="space-y-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 New Password
//               </label>
//               <input
//                 type="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-lime-400"
//                 placeholder="Enter new password"
//                 required
//                 minLength="8"
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Confirm New Password
//               </label>
//               <input
//                 type="password"
//                 value={confirmPassword}
//                 onChange={(e) => setConfirmPassword(e.target.value)}
//                 className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-lime-400"
//                 placeholder="Confirm new password"
//                 required
//                 minLength="8"
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={isLoading}
//               className={`w-full py-3 px-4 rounded-full font-bold text-white ${
//                 isLoading ? "bg-gray-400" : "bg-lime-500 hover:bg-lime-600"
//               } transition duration-200`}
//             >
//               {isLoading ? "Resetting..." : "Reset Password"}
//             </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ResetPassword;

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import api from "../api/axiosInstance";

const ResetPassword = () => {
  const location = useLocation();
  const email = location.state?.email || "";
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const navigate = useNavigate();

  const verifyOtp = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await api.post("/password/verify-reset-otp", {
        email,
        otp,
      });

      if (response.data.success) {
        toast.success("OTP verified successfully!");
        setStep(2);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid OTP");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Passwords don't match");
      return;
    }

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }

    setIsLoading(true);

    try {
      const response = await api.post("/password/reset", {
        email,
        otp,
        newPassword: password,
        confirmPassword,
      });

      if (response.data.success) {
        toast.success("Password reset successfully!");
        navigate("/login");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Password reset failed");
    } finally {
      setIsLoading(false);
    }
  };

  const resendOtp = async () => {
    try {
      await api.post("/password/forgot-password", null, { params: { email } });
      toast.success("New OTP sent to your email!");
    } catch (error) {
      toast.error(error.response?.data?.message || "Error resending OTP");
    }
  };

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField(null);
  };

  return (
    <div className="min-h-screen py-8 md:py-12 flex items-center justify-center px-4 bg-gradient-to-br from-emerald-50 via-white to-lime-50 relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-12 -right-12 w-48 h-48 bg-emerald-100 rounded-full opacity-30 blur-3xl"></div>
        <div className="absolute -bottom-12 -left-12 w-56 h-56 bg-lime-100 rounded-full opacity-30 blur-3xl"></div>
        <div className="absolute top-1/4 left-1/3 w-20 h-20 bg-emerald-50 rounded-full opacity-20"></div>
        <div className="absolute bottom-1/4 right-1/3 w-24 h-24 bg-lime-50 rounded-full opacity-20"></div>
      </div>

      {/* Key Icon Decoration */}
      <div className="absolute top-6 right-6 text-emerald-600 opacity-10">
        <svg className="w-24 h-24" fill="currentColor" viewBox="0 0 24 24">
          <path d="M21 10h-8.35C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H13l2 2 2-2 2 2 4-4.04L21 10zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z" />
        </svg>
      </div>

      <div className="relative w-full max-w-lg">
        {/* Card Container */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden border border-emerald-100">
          {/* Top accent bar */}
          <div className="h-2 bg-gradient-to-r from-emerald-400 via-lime-400 to-emerald-400"></div>

          <div className="p-6 md:p-8">
            {/* Header */}
            <div className="text-center mb-6 md:mb-8">
              <div className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 border-2 border-emerald-100 mb-4">
                {step === 1 ? (
                  <svg
                    className="w-6 h-6 md:w-7 md:h-7 text-emerald-600"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-10 6H8v1h2v1H8v1h2v2H8v2h4v-2h-2v-1h2v-1h-2v-1h2V8h-2v2zm4 6.25l-2-2h4l-2 2zM14 10l2-2 2 2h-4z" />
                  </svg>
                ) : (
                  <svg
                    className="w-6 h-6 md:w-7 md:h-7 text-emerald-600"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
                  </svg>
                )}
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                {step === 1 ? "Verify OTP" : "Set New Password"}
              </h1>
              <p className="text-gray-600 max-w-md mx-auto">
                {step === 1
                  ? `Enter the 6-digit OTP sent to ${email}`
                  : "Create a strong new password for your account"}
              </p>
            </div>

            {/* Progress Indicator */}
            <div className="flex items-center justify-center mb-8">
              <div className="flex items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    step >= 1
                      ? "bg-emerald-500 text-white"
                      : "bg-gray-200 text-gray-500"
                  }`}
                >
                  <span className="text-sm font-semibold">1</span>
                </div>
                <div
                  className={`w-12 h-1 ${
                    step >= 2 ? "bg-emerald-500" : "bg-gray-200"
                  }`}
                ></div>
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    step >= 2
                      ? "bg-emerald-500 text-white"
                      : "bg-gray-200 text-gray-500"
                  }`}
                >
                  <span className="text-sm font-semibold">2</span>
                </div>
              </div>
            </div>

            {step === 1 ? (
              <form onSubmit={verifyOtp} className="space-y-5">
                {/* OTP Field */}
                <div className="relative group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    6-Digit OTP Code
                  </label>
                  <div className="relative">
                    <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-emerald-500 transition-colors">
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.5 10.5h-9c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5zM15 9h-2V7c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v2H9c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z" />
                      </svg>
                    </div>
                    <input
                      type="text"
                      value={otp}
                      onChange={(e) =>
                        setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
                      }
                      onFocus={() => handleFocus("otp")}
                      onBlur={handleBlur}
                      className={`w-full pl-12 pr-4 py-3 md:py-4 rounded-xl bg-white border-2 text-center text-xl md:text-2xl font-mono tracking-widest transition-all duration-300 outline-none ${
                        focusedField === "otp"
                          ? "border-emerald-400 shadow-lg shadow-emerald-100"
                          : "border-gray-200 hover:border-emerald-300"
                      }`}
                      placeholder="123456"
                      required
                      maxLength={6}
                    />
                  </div>
                  <p className="text-sm text-gray-500 mt-2 text-center">
                    Check your email for the OTP
                  </p>
                </div>

                {/* Verify OTP Button */}
                <button
                  type="submit"
                  disabled={isLoading || otp.length !== 6}
                  className="group relative w-full py-3 px-6 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
                >
                  <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-emerald-400 to-lime-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <span className="relative flex items-center justify-center">
                    {isLoading ? (
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Verifying...
                      </>
                    ) : (
                      <>
                        <svg
                          className="w-5 h-5 mr-3"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        </svg>
                        VERIFY OTP
                      </>
                    )}
                  </span>
                </button>

                {/* Resend OTP */}
                <div className="text-center pt-4">
                  <button
                    type="button"
                    onClick={resendOtp}
                    className="text-emerald-600 hover:text-emerald-800 hover:underline transition-colors duration-200 font-medium flex items-center justify-center mx-auto"
                  >
                    <svg
                      className="w-4 h-4 mr-2"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
                    </svg>
                    Resend OTP
                  </button>
                </div>
              </form>
            ) : (
              <form onSubmit={handleResetPassword} className="space-y-5">
                {/* New Password Field */}
                <div className="relative group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    New Password
                  </label>
                  <div className="relative">
                    <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-emerald-500 transition-colors">
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
                      </svg>
                    </div>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onFocus={() => handleFocus("password")}
                      onBlur={handleBlur}
                      className={`w-full pl-12 pr-12 py-3 md:py-4 rounded-xl bg-white border-2 transition-all duration-300 outline-none ${
                        focusedField === "password"
                          ? "border-emerald-400 shadow-lg shadow-emerald-100"
                          : "border-gray-200 hover:border-emerald-300"
                      }`}
                      placeholder="Minimum 8 characters"
                      required
                      minLength="8"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-emerald-600 transition-colors duration-200 p-1 rounded-full hover:bg-emerald-50"
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? (
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                        </svg>
                      ) : (
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                {/* Confirm Password Field */}
                <div className="relative group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Confirm New Password
                  </label>
                  <div className="relative">
                    <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-emerald-500 transition-colors">
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
                      </svg>
                    </div>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      onFocus={() => handleFocus("confirmPassword")}
                      onBlur={handleBlur}
                      className={`w-full pl-12 pr-12 py-3 md:py-4 rounded-xl bg-white border-2 transition-all duration-300 outline-none ${
                        focusedField === "confirmPassword"
                          ? "border-emerald-400 shadow-lg shadow-emerald-100"
                          : "border-gray-200 hover:border-emerald-300"
                      }`}
                      placeholder="Confirm your password"
                      required
                      minLength="8"
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-emerald-600 transition-colors duration-200 p-1 rounded-full hover:bg-emerald-50"
                      aria-label={
                        showConfirmPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showConfirmPassword ? (
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                        </svg>
                      ) : (
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                {/* Password Requirements */}
                <div className="p-4 bg-emerald-50 rounded-lg border border-emerald-100">
                  <p className="text-sm font-medium text-emerald-800 mb-2">
                    Password Requirements:
                  </p>
                  <ul className="text-xs text-emerald-700 space-y-1">
                    <li
                      className={`flex items-center ${
                        password.length >= 8
                          ? "text-emerald-600"
                          : "text-gray-500"
                      }`}
                    >
                      <svg
                        className={`w-4 h-4 mr-2 ${
                          password.length >= 8
                            ? "text-emerald-500"
                            : "text-gray-400"
                        }`}
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        {password.length >= 8 ? (
                          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        ) : (
                          <circle cx="12" cy="12" r="10" />
                        )}
                      </svg>
                      At least 8 characters
                    </li>
                    <li
                      className={`flex items-center ${
                        password === confirmPassword && password.length >= 8
                          ? "text-emerald-600"
                          : "text-gray-500"
                      }`}
                    >
                      <svg
                        className={`w-4 h-4 mr-2 ${
                          password === confirmPassword && password.length >= 8
                            ? "text-emerald-500"
                            : "text-gray-400"
                        }`}
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        {password === confirmPassword &&
                        password.length >= 8 ? (
                          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        ) : (
                          <circle cx="12" cy="12" r="10" />
                        )}
                      </svg>
                      Passwords match
                    </li>
                  </ul>
                </div>

                {/* Reset Password Button */}
                <button
                  type="submit"
                  disabled={
                    isLoading ||
                    password !== confirmPassword ||
                    password.length < 8
                  }
                  className="group relative w-full py-3 px-6 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
                >
                  <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-emerald-400 to-lime-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <span className="relative flex items-center justify-center">
                    {isLoading ? (
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Resetting...
                      </>
                    ) : (
                      <>
                        <svg
                          className="w-5 h-5 mr-3"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
                        </svg>
                        RESET PASSWORD
                      </>
                    )}
                  </span>
                </button>

                {/* Back to OTP Verification */}
                <div className="text-center pt-4">
                  <button
                    type="button"
                    onClick={() => setStep(1)}
                    className="text-emerald-600 hover:text-emerald-800 hover:underline transition-colors duration-200 font-medium flex items-center justify-center mx-auto"
                  >
                    <svg
                      className="w-4 h-4 mr-2"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
                    </svg>
                    Back to OTP verification
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>

        {/* Footer Note */}
        <p className="text-center text-gray-400 text-sm mt-6">
          © {new Date().getFullYear()} Rangpur Golf & Country Club. Secure
          Password Reset
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
